import { Select, MenuGroup } from '@chakra-ui/react'

const SelectFilter = ({ value, setValue, options = [] }) => {
  return (
    <Select
      placeholder="All"
      value={value ?? ''}
      onChange={(e) => {
        setValue(e.target.value)
      }}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  )
}

export default SelectFilter
